/**
 * JSR
 * clanek.js
 * JQuery funkce pro stránku zobrazení článku
 *
 * @package zaklad
 *
 * @author Josef Šmíd <josef@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.5.9
 */

$(document).ready(function() 
{
  $("#pcom,a.pcom_odp").click(function() 
  {
    $("#pcom_h3").hide();
    $("table.pridatKom").fadeIn( '500' );
    $('html, body').animate({ scrollTop: $("table.pridatKom").offset().top }, 1000);
  });
  
  if ( $("table.pridatKom").is( ':visible' ) )
  {
    $('html, body').animate({ scrollTop: $("table.pridatKom").offset().top }, 1000);
  }
  
  var slider_clanky = "";
  var slider_prava_text = "";
  var slider_produkty = [];
  var slider_posledni_clanky = "";
 
  if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
  {

    slider_prava_text = $('.prava_text').bxSlider({
      mode: 'fade',
      speed: 0,
      infiniteLoop: true,
      controls: false,
      touchEnabled: true,
      adaptiveHeight: true,
      preloadImages: 'all',
      captions: true
    });

    $('.full_3').find('.bx-controls').css('top', $('.prava_text').find('img').height() + 70);

    $('.hp_produkty').each(function (i)
    {
      // bxSlider čeká na načtení všech obrázků slidů; lazy obrázky ve skrytých slidech by se nenačetly nikdy
      $(this).find('img[loading="lazy"]').attr('loading', 'eager');
      var temp = $(this).bxSlider({
        mode: 'horizontal',
        speed: 500,
        infiniteLoop: false,
        controls: true,
        touchEnabled: true,
        adaptiveHeight: false,
        preloadImages: 'all',
        captions: true
      });
      slider_produkty.push(temp);
    });

    slider_posledni_clanky = $('#posledni_clanek').bxSlider({
      mode: 'horizontal',
      speed: 500,
      infiniteLoop: false,
      controls: true,
      touchEnabled: true,
      adaptiveHeight: false,
      preloadImages: 'all',
      captions: true
    });


    slider_clanky = $('#slider_clanky').bxSlider({
      mode: 'fade',
      speed: 0,
      infiniteLoop: true,
      controls: true,
      touchEnabled: true,
      adaptiveHeight: false,
      preloadImages: 'all',
      captions: true
    });

  }

  $(window).bind("resize", function (e) {
    if (/*$('body').width() <= 1000*/window.matchMedia('(max-width: 1000px)').matches)
    {
      if (!slider_prava_text && $('.prava_text').length > 0)
        slider_prava_text = $('.prava_text').bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: false,
          touchEnabled: true,
          adaptiveHeight: true,
          preloadImages: 'all',
          captions: true
        });

      if (slider_produkty.length === 0 && $('.hp_produkty').length > 0)
      {
        $('.hp_produkty').each(function (i)
        {
          // bxSlider čeká na načtení všech obrázků slidů; lazy obrázky ve skrytých slidech by se nenačetly nikdy
          $(this).find('img[loading="lazy"]').attr('loading', 'eager');
          var temp = $(this).bxSlider({
            mode: 'horizontal',
            speed: 500,
            infiniteLoop: false,
            controls: true,
            touchEnabled: true,
            adaptiveHeight: false,
            preloadImages: 'all',
            captions: true
          });
          slider_produkty.push(temp);
        });
      }


      if (!slider_posledni_clanky && $('#posledni_clanek').length > 0)
        slider_posledni_clanky = $('#posledni_clanek').bxSlider({
          mode: 'horizontal',
          speed: 500,
          infiniteLoop: false,
          controls: true,
          touchEnabled: true,
          adaptiveHeight: false,
          preloadImages: 'all',
          captions: true
        });



      if (!slider_clanky && $('#slider_clanky').length > 0)
        slider_clanky = $('#slider_clanky').bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: true,
          adaptiveHeight: false,
          preloadImages: 'all',
          captions: true
        });

      if (slider_posledni_clanky && $('#posledni_clanek').length > 0)
        slider_posledni_clanky.reloadSlider();
      $.each(slider_produkty, function (key, value) {
        value.reloadSlider();
      });
      if (slider_prava_text && $('.prava_text').length > 0)
        slider_prava_text.reloadSlider();
      if (slider_clanky && $('#slider_clanky').length > 0)
        slider_clanky.reloadSlider();
      $('.full_3').find('.bx-controls').css('top', $('.prava_text').find('img').height() + 70);

    } else
    {
      if (slider_posledni_clanky && $('#posledni_clanek').length > 0)
        slider_posledni_clanky.destroySlider();
      $.each(slider_produkty, function (key, value) {
        value.destroySlider();
      });
      if (slider_prava_text && $('.prava_text').length > 0)
        slider_prava_text.destroySlider();
      if (slider_clanky && $('#slider_clanky').length > 0)
        slider_clanky.destroySlider();

    }



    if ($('#reference_obrazek_slider').length > 0)
    {
      $(".vybrano_ref").removeClass('vybrano_ref');
      $('*[data-slide="0"]').addClass('vybrano_ref');

      $('#reference_obrazek_slider').css('left', $('.fotogalerie_reference').css('left'));
      $('.next_slide_ref_back').hide();
      $('.next_slide_ref_front').show();
    }
  });

  $('.next_slide_ref_front').click(function () {
    if (!$(this).hasClass("dis_button"))
    {
      $(this).addClass('dis_button');

      var aktual = $('.vybrano_ref');
      var next = parseFloat(aktual.attr('data-slide')) + 1;
      var next_next = parseFloat(next) + 1;

      if ($('*[data-slide="' + next + '"]').length)
      {
        var next_el = $('*[data-slide="' + next + '"]');
        const rect = next_el[0].getBoundingClientRect();
        var posun = parseFloat(parseFloat($('#reference_obrazek_slider').css('left')) - (rect.right - $('body').width()) - parseFloat($('.slider_u_reference').css('margin-right')));

        $('#reference_obrazek_slider').animate({left: posun + 'px'}, function () {
          aktual.removeClass('vybrano_ref');
          next_el.addClass('vybrano_ref');
          if (next > 0)
            $('.next_slide_ref_back').show();

          $(".slider_u_reference").each(function (index, element) {
            if ($(element).attr("data-slide") > next)
            {
              if (isInViewport($(element)[0]))
                $('.next_slide_ref_front').hide();
              else
                $('.next_slide_ref_front').show();
            }
          });
          $('.dis_button').removeClass('dis_button');
        });
      }
      if ($('*[data-slide="' + next_next + '"]').length == 0)
      {
        $('.next_slide_ref_front').hide();
      }
    }
  });
  $('.next_slide_ref_back').click(function () {
    if (!$(this).hasClass("dis_button"))
    {
      $(this).addClass('dis_button');

      var aktual = $('.vybrano_ref');
      var next = parseFloat(aktual.attr('data-slide')) - 1;

      if ($('*[data-slide="' + next + '"]').length)
      {
        if (next === 0)
        {
          $('#reference_obrazek_slider').animate({left: parseFloat($('.fotogalerie_reference').css('left')) + 'px'}, function () {
            aktual.removeClass('vybrano_ref');
            var next_el = $('*[data-slide="' + next + '"]');
            next_el.addClass('vybrano_ref');
          });
          $('.next_slide_ref_back').hide();
          $('.next_slide_ref_front').show();
        } else
        {
          var next_el = $('*[data-slide="' + next + '"]');
          const rect = next_el[0].getBoundingClientRect();

          var posun = parseFloat(parseFloat($('#reference_obrazek_slider').css('left')) - (rect.right - $('body').width()) - parseFloat($('.slider_u_reference').css('margin-right')));

          $('#reference_obrazek_slider').animate({left: '-' + -posun + 'px'}, function () {
            aktual.removeClass('vybrano_ref');
            next_el.addClass('vybrano_ref');
            if (next == 0)
              $('.next_slide_ref_back').hide();
            $('.next_slide_ref_front').show();

            $('.dis_button').removeClass('dis_button');
          });
        }
      }
    }
  });

  $('.fotogalerie_reference .fotka').click(function () {

    var aktual = $('.vybrano_ref');
    var next = parseFloat($(this).attr('data-slide'));
    if (parseFloat(aktual.attr('data-slide')) == next)
      return;
    var next_next = parseFloat(next) + 1;

    var aktual_index = parseFloat(aktual.attr('data-slide'));
    if ($('*[data-slide="' + next + '"]').length)
    {
      if (aktual_index < next)
      {
        var next_el = $('*[data-slide="' + next + '"]');
        const rect = next_el[0].getBoundingClientRect();
        var posun = parseFloat(parseFloat($('#reference_obrazek_slider').css('left')) - (rect.right - $('body').width()) - parseFloat($('.slider_u_reference').css('margin-right')));

        $('#reference_obrazek_slider').animate({left: posun + 'px'}, function () {
          aktual.removeClass('vybrano_ref');
          next_el.addClass('vybrano_ref');
          if (next > 0)
            $('.next_slide_ref_back').show();

          $(".slider_u_reference").each(function (index, element) {
            if ($(element).attr("data-slide") > next)
            {
              if (isInViewport($(element)[0]))
                $('.next_slide_ref_front').hide();
              else
                $('.next_slide_ref_front').show();
            }
          });
        });
      } else
      {
        if (next === 0)
        {
          $('#reference_obrazek_slider').animate({left: parseFloat($('.fotogalerie_reference').css('left')) + 'px'}, function () {
            aktual.removeClass('vybrano_ref');
            var next_el = $('*[data-slide="' + next + '"]');
            next_el.addClass('vybrano_ref');
          });
          $('.next_slide_ref_back').hide();
          $('.next_slide_ref_front').show();
        } else
        {
          var next_el = $('*[data-slide="' + next + '"]');
          const rect = next_el[0].getBoundingClientRect();

          var posun = parseFloat(parseFloat($('#reference_obrazek_slider').css('left')) - (rect.right - $('body').width()) - parseFloat($('.slider_u_reference').css('margin-right')));

          $('#reference_obrazek_slider').animate({left: '-' + -posun + 'px'}, function () {
            aktual.removeClass('vybrano_ref');
            next_el.addClass('vybrano_ref');
            if (next == 0)
              $('.next_slide_ref_back').hide();
            $('.next_slide_ref_front').show();
          });
        }
      }
    }
    if ($('*[data-slide="' + next_next + '"]').length == 0)
    {
      $('.next_slide_ref_front').hide();
    }
  });
  
  var slider_reference = null;
  if (window.matchMedia('(max-width: 600px)').matches)
  {
    if (!slider_reference && $('#reference_obrazek_slider').length > 0)
      slider_reference = $('#reference_obrazek_slider').bxSlider({
        mode: 'fade',
        speed: 0,
        infiniteLoop: true,
        controls: true,
        touchEnabled: true,
        adaptiveHeight: false,
        preloadImages: 'all',
        captions: true
      });

  }
  $(window).bind("resize", function (e) {
    if (window.matchMedia('(max-width: 600px)').matches)
    {
      $('#reference_obrazek_slider').css('left', 0);
      if (!slider_reference && $('#reference_obrazek_slider').length > 0)
        slider_reference = $('#reference_obrazek_slider').bxSlider({
          mode: 'fade',
          speed: 0,
          infiniteLoop: true,
          controls: true,
          touchEnabled: true,
          adaptiveHeight: false,
          preloadImages: 'all',
          captions: true
        });
      if (slider_reference && $('#reference_obrazek_slider').length > 0)
        slider_reference.reloadSlider();
    } else
    {
      $('.kategorie_buttons_select').show();
      if (slider_reference && $('#reference_obrazek_slider').length > 0)
        slider_reference.destroySlider();
    }
    $('.dis_button').removeClass('dis_button');
  });
  
});